@use '../../../variables';

.container {
  margin: 0 auto 1.6rem;
  width: 100%;
  max-width: 80rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 0 1.6rem 1.6rem 1.6rem;

  @media screen and (min-width: variables.$bp-medium) {
    padding: initial;
  }
}

.properties {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: .8rem;
}

.divider {
  height: 1px;
  width: 100%;
  background: var(--content-border-color);
  border: none;
}

.comment {
  & > :not(:first-child) {
    margin-inline-start: 1.6rem;
  }
}

.title {
  input {
    font-size: 1.8rem;
    font-weight: 600;
  }
}

.discussion-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
